import {useEffect} from "react";

const CallFunc = () => {
  useEffect(() => {
    // allFunc($);
  });
}

export default CallFunc;